import React from 'react'
import Logo from "../assets/images/sf_logo.png"
export default function Loading() {
  return (
    <div className="bg-banner h-screen w-full flex justify-center items-center">
      <section className="flex items-center space-x-1">
      <img src={Logo} alt="logo" width="130" />
      <p>Loading...</p>
      </section>
     
    </div>
  )
}